import { EmptyState } from "@swot/base-components";

export function CmtsSmartDataGridEmptyState(props: { message?: string | undefined }) {
  return (
    <EmptyState
      title="No records found"
      message={props.message ?? "No rows match the current filter, permission scope, or search text."}
    />
  );
}
